import { render, staticRenderFns } from "./EmployeeConcerns.vue?vue&type=template&id=820e8590&scoped=true"
import script from "./EmployeeConcerns.vue?vue&type=script&lang=js"
export * from "./EmployeeConcerns.vue?vue&type=script&lang=js"
import style0 from "./EmployeeConcerns.vue?vue&type=style&index=0&id=820e8590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820e8590",
  null
  
)

export default component.exports